import { Injectable, Type } from '@angular/core';
import * as _ from 'lodash';
import { WidgetContainer } from '../models/WidgetContainer';
import { Layout } from '../models/Layout';
import { Surface } from '../models/Surface';

@Injectable()
export class DashboardsLayoutService {
    private layouts: Layout[];

    constructor () {
        this.layouts = [];
    }

    register(layoutType: string, surfaceComponent: Type<Surface>) {
        if (!layoutType) {
            throw new Error('Layout type is empty.');
        }

        if (this.exists(layoutType)) {
            throw new Error(`Layout type ${layoutType} already registered.`);
        }

        this.layouts.push({
            type: layoutType,
            surfaceComponent: surfaceComponent
        });
    }

    getLayout(layoutType: string) {
        return _.find(this.layouts, (layout) => {
            return layout.type === layoutType;
        });
    }

    getSurfaceComponent(layoutType: string): Type<Surface> {
        const layout = this.getLayout(layoutType);
        return layout ? layout.surfaceComponent : null;
    }

    private exists(layoutType: string): boolean {
        return _.find(this.layouts, (layout: Layout) => {
            return layout.type === layoutType;
        }) !== undefined;
    }
}
